// extracted by mini-css-extract-plugin
module.exports = {"terms":"wap_terms__lBezQ","main":"wap_main__tc5DK"};